import { Backdrop } from '@mui/material'
import React from 'react'
import './CircleLoading.scss'

const CircleLoading = () => {
    return (
        <Backdrop open={true} sx={{
            zIndex: 10,
            color: '#fff'
        }}>
            <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </Backdrop>
    )
}

export default CircleLoading